import { Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';

@Component({
  selector: 'app-deposit-order',
  templateUrl: './deposit-order.component.html',
  styleUrls: ['./deposit-order.component.scss']
})
export class DepositOrderComponent implements OnInit {
  @Input() eCaseId:any;
  caseId:any;
  depositOrdersArr:any=[];
  closeResult: string;
  isValidIqamaNumber:boolean=true;
  isValidIdentityNumber:boolean=true;
  identityTypesArr:any=[];
  branchesArr:any=[];
  depositOrderNumber: any;
  period: any;
  depositDate:any;
  today = new Date();
  currentDate:NgbDateStruct;
  isNormal: any;
  depositAreaId: any;
  reason: any;
  notes: any;
  dipositorName: any;
  dipositorIentiyTypeId: any;
  dipositorNId: string = '';
  employeeName: any;
  employeeNId: string='';
  employeeNIdIsValid:boolean=true;
  officerName: any;
  officerNId: string = '';
  officerNIdIsValid:boolean=true;
  isVisitAllowed: any ;
  caseDetails:any;
  depositOrderId:any;
  editedDepositOrder:any;
  editedDate:NgbDateStruct;
  employeeNIdEditIsValid:boolean=true;
  officerNIdEditIsValid:boolean=true;
  showAddPage : Boolean = false;
  showEditPage : Boolean = false;
  constructor(private dateformat: DateFormatterService,private caseService : CaseService ,  private modalService: NgbModal,public sharedService : SharedHttpService,private lookupService : LookupService,public toastr:ToastrService) { }

  ngOnInit(): void {
    this.loadData();
    this.caseId = this.caseService.case.caseId;
    this.caseDetails=this.caseService.case;
    this.identityTypesArr =this.lookupService.getLockup('identitytypes');
    this.branchesArr = this.lookupService.getLockup('depositarea');
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
    this.depositDate = this.dateformat.ToGregorian2(this.currentDate );
  }
  loadData(){
    this.sharedService.get(`api/DepositOrder/GetDieposits?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.depositOrdersArr = res;
    })
    
  }
  openCreateModal(){
    this.showAddPage=true;
    // this.sharedService.openLarge(modal);
  }

  changeIdentityType(){
    this.dipositorNId = '';
    if(this.editedDepositOrder){
      this.editedDepositOrder.dipositorNId='';
    }
    this.isValidIdentityNumber = true;
    this.isValidIqamaNumber = true
  }
  SelectedDateChange($event) {
    this.depositDate = this.dateformat.ToGregorian2($event);
  }
  numberOnly(event,dipositorNId) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern =/^\d+$/;
    if(dipositorNId){
      
      this.isValidIdentityNumber=true;
      this.isValidIqamaNumber=true;
      // if(this.dipositorNId==''&& event){
      //   this.dipositorNId=event.key;
      // }
      if(this.editedDepositOrder){
        if(this.editedDepositOrder.dipositorIentiyTypeId==1 && !this.editedDepositOrder.dipositorNId.startsWith('1') ){
          this.isValidIdentityNumber=false;
        }else{
          this.isValidIdentityNumber=true;
        }
        if(this.editedDepositOrder.dipositorIentiyTypeId==2 && !this.editedDepositOrder.dipositorNId.startsWith('2') ){
          this.isValidIqamaNumber=false;
        }else{
          this.isValidIqamaNumber=true;
        }
        if(this.editedDepositOrder.employeeNId =='' || (this.editedDepositOrder.employeeNId.startsWith('1') || this.editedDepositOrder.employeeNId.startsWith('2'))){
          this.employeeNIdEditIsValid=true;

        }else{
          this.employeeNIdEditIsValid=false;
        }
        if(this.editedDepositOrder.officerNId=='' || (this.editedDepositOrder.officerNId.startsWith('1') || this.editedDepositOrder.officerNId.startsWith('2'))){
          this.officerNIdEditIsValid=true;
        }else{
          this.officerNIdEditIsValid=false;
  
        }
      }else{
        if(this.dipositorIentiyTypeId==1 && !this.dipositorNId.startsWith('1') ){
          this.isValidIdentityNumber=false;
        }else{
          this.isValidIdentityNumber=true;
        }
        if(this.dipositorIentiyTypeId==2 && !this.dipositorNId.startsWith('2') ){
          this.isValidIqamaNumber=false;
        }else{
          this.isValidIqamaNumber=true;
        }

        if(this.employeeNId =='' || (this.employeeNId.startsWith('1') || this.employeeNId.startsWith('2'))){
          this.employeeNIdIsValid=true;

        }else{
          this.employeeNIdIsValid=false;
        }
        if(this.officerNId=='' || (this.officerNId.startsWith('1') || this.officerNId.startsWith('2'))){
          this.officerNIdIsValid=true;
        }else{
          this.officerNIdIsValid=false;
  
        }

      }
    }
    
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  AddDepositOrder(){
    let obj={
      "caseId":this.caseId,
      "depositOrderNumber": this.depositOrderNumber,
      "period": this.period,
      "depositDate":this.depositDate,
      "isNormal": this.isNormal,
      "depositAreaId": this.depositAreaId,
      "reason": this.reason,
      "notes": this.notes,
      "dipositorName": this.dipositorName,
      "dipositorIentiyTypeId": this.dipositorIentiyTypeId,
      "dipositorNId": this.dipositorNId,
      "employeeName": this.employeeName,
      "employeeNId": this.employeeNId,
      "officerName": this.officerName,
      "officerNId": this.officerNId,
      "isVisitAllowed": this.isVisitAllowed,
      "isDeleted": false,
    };
    this.sharedService.post(`api/DepositOrder/Insert`,[obj]).subscribe(res=>{
      // modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("DepositOrderAdded");
      this.depositOrderNumber = undefined;
      this.period = undefined;
      this.depositDate = undefined;
      this.isNormal = undefined
        this.depositAreaId = undefined;
      this.reason = undefined;
      this.notes = undefined;
      this.dipositorName = undefined;
      this.dipositorIentiyTypeId = undefined;
      this.dipositorNId = undefined;
      this.employeeName = undefined;
      this.employeeNId = '';
      this.officerName = undefined;
      this.officerNId = '';
      this.isVisitAllowed = undefined;
      this.loadData();
      this.showAddPage=false;
    });
  }
  deleteDepositOrder(depositOrderId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.depositOrderId = depositOrderId;
  }


  onDeleteDepositOrder(modal) {
    this.sharedService.delete(`api/DepositOrder/Delete`, [this.depositOrderId]).subscribe((response) => {
      this.loadData();
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("DepositOrderDeleteSuccessfully");
      },
     
    );
  }
  editDepositOrder(depositOrder){
    this.editedDepositOrder=undefined;
    this.editedDepositOrder= {...depositOrder};
    this.editedDate = this.sharedService.convertDateToNgbDateStruct(this.editedDepositOrder.depositDate);
    // this.sharedService.openLarge(modal);
    this.showEditPage=true;
  }
  SelectedDateChangeEdit($event) {
    this.editedDepositOrder.depositDate = this.dateformat.ToGregorian2($event);
  }
 
  onEditDepositOrder() {
    let obj = {
      "depositOrderId": this.editedDepositOrder.depositOrderId,
      "caseId": this.caseId,
      "depositOrderNumber": this.editedDepositOrder.depositOrderNumber,
      "period": this.editedDepositOrder.period,
      "depositDate": this.editedDepositOrder.depositDate,
      "isNormal": this.editedDepositOrder.isNormal,
      "depositAreaId": this.editedDepositOrder.depositAreaId,
      "reason": this.editedDepositOrder.reason,
      "notes": this.editedDepositOrder.notes,
      "dipositorName": this.editedDepositOrder.dipositorName,
      "dipositorIentiyTypeId": this.editedDepositOrder.dipositorIentiyTypeId,
      "dipositorNId": this.editedDepositOrder.dipositorNId,
      "employeeName": this.editedDepositOrder.employeeName,
      "employeeNId": this.editedDepositOrder.employeeNId,
      "officerName": this.editedDepositOrder.officerName,
      "officerNId": this.editedDepositOrder.officerNId,
      "isVisitAllowed": this.editedDepositOrder.isVisitAllowed,
      "isDeleted": false,
    };
    this.sharedService.put(`api/DepositOrder/Update`, [obj]).subscribe(res => {
      // modal.dismiss('Cross click');
      this.showEditPage=false;
      this.loadData();
      this.sharedService.showSuccessKey("DepositOrderEditSuccessfully");
    });
  }
  depositOrderPreview(depositeOrder,modal){
    this.editedDepositOrder=undefined;
    this.editedDepositOrder= {...depositeOrder};
    this.sharedService.openLarge(modal);
  }

}
